import { STATUS_CONFIG } from "@/data/mockData";

export const StatusBadge = ({ status, testId }) => {
  const c = STATUS_CONFIG[status];
  if (!c) return null;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-2 rounded-full border ${c.bg} ${c.text} ${c.border} px-3 py-1 text-xs font-semibold`}
    >
      <span className="relative flex h-1.5 w-1.5">
        {status !== "atendido" && (
          <span className={`pulse-ring absolute inline-flex h-full w-full rounded-full ${c.dot} opacity-75`} />
        )}
        <span className={`relative inline-flex h-1.5 w-1.5 rounded-full ${c.dot}`} />
      </span>
      {c.label}
      {c.sublabel && <span className="font-normal opacity-70">· {c.sublabel}</span>}
    </span>
  );
};
